import React, { Component } from "react";
import { Container } from "react-bootstrap";
import "./CareerDetails.css";
import withRouter from "../../withRouter";
import ContactUsFooter from "../../components/ContactUsFooter/contactUsFooter";
import Footer from "../../components/Footer/Footer";


class CareerDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "application",
      resume: null,
      firstName: "",
      lastName: "",
      email: "",
      contactNumber: "",
      coverLetterFile: null,
      expectedSalary: "",
      agree: false,
      jobDetails: null,
      fieldErrors: {},
      submitError: "",
      isSubmitting: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const jobId = this.props.location.state?.jobId;

    if (!jobId) {
      this.props.navigate("/careers");
      return;
    }

    const url = `https://ambrumsolutions.com/api/ambrum-website/get-job-details?job_id=${jobId}`;
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          this.setState({ jobDetails: data.data, activeTab: "overview" });
        }
      })
      .catch((err) => console.error("Error fetching job details:", err));
  }

  setActiveTab = (tab) => {
    this.setState({ activeTab: tab });
  };

  handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState({ [name]: type === "checkbox" ? checked : value });
  };

  handleCoverLetterFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState({ coverLetterFile: file });
    }
  };

  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "application/pdf") {
      this.setState({
        resume: file,
        fieldErrors: {
          ...this.state.fieldErrors,
          resume: "",
        },
      });
    } else {
      this.setState({
        resume: null,
        fieldErrors: {
          ...this.state.fieldErrors,
          resume: "Only PDF files are allowed.",
        },
      });
    }
  };


  handleSubmit = (e) => {
    e.preventDefault();

    const {
      jobDetails,
      resume,
      firstName,
      lastName,
      email,
      contactNumber,
      coverLetter,
      expectedSalary,
    } = this.state;

    const fieldErrors = {};


    if (!resume) {
      this.setState({
        isSubmitting: false,
        submitError: "Please upload your resume before submitting.",
      });
      return;
    }
    if (!firstName.trim()) fieldErrors.firstName = "First name is required.";
    if (!lastName.trim()) fieldErrors.lastName = "Last name is required.";
    if (!email.trim()) fieldErrors.email = "Email is required.";
    if (!contactNumber.trim()) fieldErrors.contactNumber = "Contact number is required.";
    //  if (!coverLetter.trim()) fieldErrors.coverLetter = "Cover letter is required.";
    if (!expectedSalary.trim()) fieldErrors.expectedSalary = "Expected salary is required.";

    if (Object.keys(fieldErrors).length > 0) {
      this.setState({ fieldErrors, submitError: "Please fix the errors below." });
      return;
    }

    this.setState({ isSubmitting: true, fieldErrors: {}, submitError: "" });


    const formData = new FormData();
    formData.append("job_title", jobDetails?.job_title || "");
    formData.append("first_name", firstName);
    formData.append("last_name", lastName);
    formData.append("e_mail", email);
    formData.append("contact_number", contactNumber);
    if (this.state.coverLetterFile) {
      formData.append("cover_letter", this.state.coverLetterFile);
    }
    formData.append("expected_salary", expectedSalary);
    formData.append("resume", resume);

    fetch("https://ambrumsolutions.com/api/ambrum-website/submit-application", {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status || data.code === 200) {
          this.props.navigate("/application-success");
        } else {
          this.setState({
            submitError: data.message || "Submission failed. Please try again.",
            isSubmitting: false,
          });
          window.scrollTo(0, 0);
          console.error("Submission error:", data);
        }
      })
      .catch((err) => {
        this.setState({
          submitError: "Something went wrong. Please try again later.",
          isSubmitting: false,
        });
        window.scrollTo(0, 0);
        console.error("Error submitting form:", err);
      });
  };


  renderContent() {
    const { activeTab, jobDetails } = this.state;

    if (activeTab === "overview") {
      if (!jobDetails) return <div>Loading job details...</div>;

      return (
        <div>
          <div className="w-75">
            <p className="my-4">{jobDetails.job_description}</p>
            <div className="mb-5">
              <h5>Responsibilities</h5>
              <ul>
                {jobDetails.job_responsibilities.split("\n").map((line, index) => (
                  <li key={index}>{line}</li>
                ))}
              </ul>
            </div>
            <h5>Qualifications & Requirements</h5>
            <ul>
              {jobDetails.job_qualification.split("\n").map((line, index) => (
                <li key={index}>{line}</li>
              ))}
            </ul>
            {jobDetails.other_info && jobDetails.other_info.trim() !== "" && (
              <>
                <h5>What we Offer</h5>
                <ul>
                  {jobDetails.other_info.split("\n").map((line, index) => (
                    <li key={index}>{line}</li>
                  ))}
                </ul>
              </>
            )}
          </div>
          <div className="pt-5 mb-4">
            If you meet the requirements above, <br />
            We are looking for YOU!
          </div>
          <div className="mt-4">
            <button
              className="primary-btn fw-500"
              onClick={() => this.setActiveTab("application")}
            >
              Apply Now {">"}
            </button>
          </div>
        </div>
      );
    }

    if (activeTab === "application") {
      return (
        <div className="form-container">
          <h2>Apply For this Job</h2>
          {this.state.submitError && (
            <div className="form-error">{this.state.submitError}</div>
          )}
          {this.state.fieldErrors.firstName && (
            <div className="form-error">{this.state.fieldErrors.firstName}</div>
          )}
          <form onSubmit={this.handleSubmit} className="job-form">
            <label>Resume/CV<span className="required">*</span></label>
            <div className="file-upload-box p-5 d-flex flex-column align-items-center">
              <input
                type="file"
                accept="application/pdf"
                onChange={this.handleFileChange}
              />
              <div className="w-50">
                <img src="./assets/icons/upload.gif" className="w-25" alt="upload" />
              </div>
              <p>Click or drag file to this area to upload your Resume</p>
              <small>Please make sure to upload a PDF</small>

              {this.state.resume && (
                <div className="uploaded-file mt-2">
                  <i className="fa fa-file-pdf text-danger me-2"></i>
                  {this.state.resume.name}
                </div>
              )}

              {this.state.fieldErrors.resume && (
                <div className="form-error mt-2">{this.state.fieldErrors.resume}</div>
              )}
            </div>

            <label>First Name<span className="required">*</span></label>
            <input
              type="text"
              name="firstName"
              value={this.state.firstName}
              onChange={this.handleChange}
              required
            />

            <label>Last Name<span className="required">*</span></label>
            <input
              type="text"
              name="lastName"
              value={this.state.lastName}
              onChange={this.handleChange}
              required
            />

            <label>E-mail<span className="required">*</span></label>
            <input
              type="email"
              name="email"
              value={this.state.email}
              onChange={this.handleChange}
              required
            />

            <label>Contact Number<span className="required">*</span></label>
            <input
              type="text"
              name="contactNumber"
              value={this.state.contactNumber}
              onChange={this.handleChange}
              required
            />

            <label>Cover Letter</label>
            <div className="file-upload-box p-4 d-flex flex-column align-items-center">
              <input
                type="file"
                accept="application/pdf,image/*"
                onChange={this.handleCoverLetterFileChange}
              />
              <small>Upload PDF or image (optional)</small>

              {this.state.coverLetterFile && (
                <div className="uploaded-file mt-2">
                  <i className="fa fa-file-alt text-primary me-2"></i>
                  {this.state.coverLetterFile.name}
                </div>
              )}
            </div>


            <label>What is your expected salary for this position?<span className="required">*</span></label>
            <input
              type="text"
              name="expectedSalary"
              value={this.state.expectedSalary}
              onChange={this.handleChange}
              required
            />

            <div className="checkbox-wrapper">
              <input
                type="checkbox"
                name="agree"
                checked={this.state.agree}
                onChange={this.handleChange}
              />
              <span>
                I agree to give the above personal data to Ambrum. Ambrum may
                use the data to evaluate, store for further processing and use
                anonymized data to train our models to improve our recruitment
                process.
              </span>
            </div>
            <button
              type="submit"
              className="submit-btn"
              disabled={!this.state.agree || this.state.isSubmitting}
            >
              {this.state.isSubmitting ? (
                <>
                  <span className="button-spinner"></span>
                  Submitting...
                </>
              ) : (
                "Submit"
              )}
            </button>

          </form>
        </div>
      );
    }

    return null;
  }

  render() {
    const { activeTab, jobDetails } = this.state;

    return (
      <div>
        <Container className="mt-9">
          <div className="tabs-container">
            <div
              className={`tab ${activeTab === "overview" ? "active" : ""}`}
              onClick={() => this.setActiveTab("overview")}
            >
              Overview
            </div>
            <div
              className={`tab ${activeTab === "application" ? "active" : ""}`}
              onClick={() => this.setActiveTab("application")}
            >
              Application
            </div>
          </div>

          <div className="hero-text-2">
            {jobDetails?.job_title || "Job Title"}
          </div>

          <div className="mt-4 my-5 d-flex">
            <div className="bg-light w-fc me-2 rounded-pill p-2">
              <i className="fa-solid fa-laptop me-1"></i>Onsite
            </div>
            <div className="bg-light w-fc rounded-pill p-2">
              <i className="fa-solid fa-location-dot me-1"></i>Colombo
            </div>
            <div className="bg-light w-fc rounded-pill p-2">
              <i class="fa-solid fa-clock me-1"></i> Full Time
            </div>
          </div>

          <div>{this.renderContent()}</div>

        </Container>
        <ContactUsFooter />
        <br />
        <Footer />
      </div>
    );
  }
}

export default withRouter(CareerDetails);
